import FeatureToggle from './FeatureToggle';
import featureToggleServerSide from './featureToggleServerSide';

export { featureToggleServerSide };
export default FeatureToggle;
